import styled, { css } from 'styled-components'

import {
  BaseButton,
  type IBaseButtonProps,
} from '../../../../elements/Button/BaseButton'

export interface IButtonGroupButtonProps extends IBaseButtonProps {
  active?: boolean
}

export const ButtonGroupButton = styled((props: IButtonGroupButtonProps) => (
  <BaseButton type='button' {...props} />
))`
  position: relative;

  ${(props) => {
    const button = props.theme.colors.button.group

    return css`
      ${props.active
        ? css`
            color: ${button.content.active};
            background-color: ${button.background.active};
            border-color: ${button.border.active};

            &:visited {
              color: ${button.content.active};
            }

            &:hover {
              color: ${button.content.active};
              background-color: ${button.background.activeHover};
              border-color: ${button.border.active};
            }

            &:active {
              color: ${button.content.active};
              background-color: ${button.background.active};
              border-color: ${button.border.active};
            }
          `
        : css`
            color: ${button.content.default};
            background-color: ${button.background.default};
            border-color: ${button.border.default};

            &:visited {
              color: ${button.content.default};
            }

            &:hover {
              color: ${button.content.default};
              background-color: ${button.background.hover};
              border-color: ${button.border.default};
            }

            &:active {
              color: ${button.content.default};
              background-color: ${button.background.default};
              border-color: ${button.border.default};
            }
          `}

      &[disabled] {
        color: ${button.content.disabled};
        background-color: ${button.background.default};
        border-color: ${button.border.default};

        &:hover,
        &:active {
          color: ${button.content.disabled};
          background-color: ${button.background.default};
          border-color: ${button.border.default};
        }
      }
    `
  }}
`

ButtonGroupButton.displayName = 'ButtonGroupButton'
